import { Badge } from '@/components/ui/badge'
import { amberChipClass, lastContactState, relatiefNl } from '../contactDisplay'
import { todayIso } from '../dates'

/**
 * "Laatste contact" in three states that differ without colour (addendum A.6, ED-64): "Nog geen
 * contact" in grey and without a chip, the age of the contact, and "Te lang stil" next to it only
 * after contact that is more than 90 days old.
 */
export function LastContactCell({ lastContactAt, today = todayIso() }: { lastContactAt: string | null; today?: string }) {
  const state = lastContactState(lastContactAt, today)
  if (state === 'geen' || !lastContactAt) return <span className="text-muted-foreground">Nog geen contact</span>
  return (
    <div className="flex items-center gap-2">
      <span className="text-muted-foreground">{relatiefNl(lastContactAt)}</span>
      {state === 'stil' ? (
        <Badge variant="outline" className={amberChipClass}>
          Te lang stil
        </Badge>
      ) : null}
    </div>
  )
}
